import {
  REQUESTED_VALIDATE,
  REQUESTED_VALIDATE_SUCCEEDED,
  REQUESTED_VALIDATE_FAILED,
} from "./types"

export const requestValidate = config => {
  return { type: REQUESTED_VALIDATE, config }
}

export const requestValidateSuccess = (action, response) => {
  return { type: REQUESTED_VALIDATE_SUCCEEDED, action, response }
}

export const requestValidateError = (action, error) => {
  return { type: REQUESTED_VALIDATE_FAILED, action, error }
}
